(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yodlo-ajanlott"]) return;
  try {
    
(() => {
  if (customElements.get("yd-ajanlott")) return;
  const ROOT = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  const FK = "yd-kedvencek";
  const txt = (el) => (el ? el.textContent.replace(/\s+/g, " ").trim() : "");
  const favGet = () => { try { const v = JSON.parse(localStorage.getItem(FK) || "[]"); return Array.isArray(v) ? v : []; } catch (e) { return []; } };
  const favSet = (a) => { try { localStorage.setItem(FK, JSON.stringify(a)); } catch (e) {} document.dispatchEvent(new CustomEvent("yd:kedvencek")); };
  const favSync = () => {
    const s = new Set(favGet().map((x) => x.u));
    document.querySelectorAll(".yd-aj .yd-fav").forEach((b) => { const on = s.has(b.dataset.u); b.classList.toggle("on", on); b.setAttribute("aria-pressed", on ? "true" : "false"); });
  };
  const status = (root, t) => { const s = root.querySelector(".yd-status"); if (!s) return; s.textContent = ""; setTimeout(() => { s.textContent = t; }, 50); };

  class YdAjanlott extends HTMLElement {
    connectedCallback() {
      if (this.querySelector(".yd-grid") || this._busy) { favSync(); return; }
      this._busy = true;
      fetch(this.dataset.url).then((r) => (r.ok ? r.text() : "")).then((t) => {
        const d = new DOMParser().parseFromString(t, "text/html").querySelector("yd-ajanlott");
        if (d && d.querySelector(".yd-grid")) { this.innerHTML = d.innerHTML; favSync(); }
      }).catch(() => {}).finally(() => { this._busy = false; });
    }
  }
  customElements.define("yd-ajanlott", YdAjanlott);

  document.addEventListener("click", async (e) => {
    const fav = e.target.closest(".yd-aj .yd-fav");
    if (fav) {
      e.preventDefault();
      const card = fav.closest(".yd-card"), img = card.querySelector(".yd-img1"), a = favGet(), i = a.findIndex((x) => x.u === fav.dataset.u);
      if (i > -1) a.splice(i, 1);
      else a.unshift({ u: fav.dataset.u, t: txt(card.querySelector(".yd-ctitle a")), i: img ? img.currentSrc || img.src : "", p: txt(card.querySelector(".yd-pr-now")), b: txt(card.querySelector(".yd-brand")) });
      favSet(a.slice(0, 60));
      favSync();
      return;
    }
    const b = e.target.closest(".yd-aj button.yd-btn[data-v]");
    if (!b || b.disabled) return;
    const root = b.closest(".yd-aj"), st = root.querySelector(".yd-status");
    b.disabled = true;
    b.setAttribute("aria-busy", "true");
    let ok = false;
    try {
      const r = await fetch(ROOT() + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(Object.assign({ items: [{ id: Number(b.dataset.v), quantity: Number(b.dataset.q) || 1 }] }, window.ydFiok ? window.ydFiok.szekciok() : {}))
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.description || d.message || "");
      const c = await (await fetch(ROOT() + "cart.js", { headers: { Accept: "application/json" } })).json();
      document.dispatchEvent(new CustomEvent("yodlo:kosar", { detail: { item_count: c.item_count } }));
      if (typeof window.publish === "function" && typeof window.PUB_SUB_EVENTS !== "undefined") window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: "yodlo-ajanlott", cartData: c });
      if (window.ydFiok) window.ydFiok.nyit(d);
      ok = true;
      status(root, (st ? st.dataset.ok : "") + " " + (b.dataset.nev || ""));
    } catch (err) {
      status(root, [(st ? st.dataset.hiba : ""), err.message].filter(Boolean).join(" "));
    }
    b.removeAttribute("aria-busy");
    b.classList.add(ok ? "ok" : "err");
    setTimeout(() => { b.classList.remove("ok", "err"); b.disabled = false; }, ok ? 900 : 1800);
  });
  document.addEventListener("yd:kedvencek", favSync);
  window.addEventListener("storage", (e) => { if (e.key === FK) favSync(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yodlo-alap"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('yd-alap')) {
  // „További termékek” gomb a Dawn számozott lapozója helyett (kollekció és keresés). A következő oldalt a szekció-renderrel
  // tölti be és a rácshoz fűzi; a szűrők újrarajzolása után újraépül; visszalépéskor a betöltött oldalakat visszatölti.
  // Csak az 1. oldalon indul: közvetlen ?page=3 linknél és JS nélkül a számozott lapozó marad.
  const ydTobb = (el) => {
    const T = {
      gomb: el.dataset.tobbGomb || 'További [db] termék', allapot: el.dataset.tobbAllapot || '', vege: el.dataset.tobbVege || '',
      tolt: el.dataset.tobbTolt || 'Betöltés', kesz: el.dataset.tobbKesz || '', hiba: el.dataset.tobbHiba || ''
    };
    const kulcs = () => { const u = new URL(location.href); u.searchParams.delete('page'); return 'yd-tobb:' + u.pathname + u.search; };
    const kovetkezo = (root) => root && root.querySelector('a.pagination__item--prev.pagination__item-arrow');
    let cur = null;
    const epit = () => {
      if (cur) { cur.d.remove(); cur = null; }
      const box = document.getElementById('ProductGridContainer');
      const wrap = box && box.querySelector('.pagination-wrapper');
      const ul = box && box.querySelector('ul.product-grid');
      const idEl = box && box.querySelector('[data-id]');
      const a = wrap && kovetkezo(wrap);
      if (!ul || !idEl || !a || wrap.dataset.page !== '1') return null;
      const sid = idEl.dataset.id, per = ul.children.length;
      const pc = document.getElementById('ProductCount');
      const total = pc ? parseInt(pc.dataset.productCount, 10) || 0 : 0;
      let url = a.getAttribute('href'), n = 1, busy = false;
      const d = document.createElement('div');
      d.className = 'yd-tobb';
      d.innerHTML = '<p class="yd-tobb__allapot"></p><button type="button" class="button button--secondary yd-tobb__gomb"></button><p class="visually-hidden" role="status"></p>';
      const [pa, btn, live] = d.children;
      const irj = () => {
        const lat = ul.children.length;
        if (!url) {
          btn.remove();
          pa.textContent = total && T.vege ? T.vege.replace('[osszes]', total) : '';
        } else {
          btn.textContent = T.gomb.replace('[db]', total ? Math.min(per, Math.max(total - lat, 1)) : per);
          pa.textContent = total && T.allapot ? T.allapot.replace('[latott]', lat).replace('[osszes]', total) : '';
        }
        pa.hidden = !pa.textContent;
      };
      const tolt = async () => {
        if (busy || !url) return null;
        busy = true;
        // disabled helyett aria-disabled: a letiltott gomb elvesztené a billentyűs fókuszt
        btn.setAttribute('aria-disabled', 'true'); btn.setAttribute('aria-busy', 'true'); btn.textContent = T.tolt;
        let elso = null;
        try {
          const u = new URL(url, location.origin);
          u.searchParams.set('section_id', sid);
          const r = await fetch(u, { credentials: 'same-origin' });
          if (!r.ok) throw new Error(String(r.status));
          const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
          const g = doc.querySelector('ul.product-grid');
          const uj = g ? [...g.children] : [];
          if (!uj.length) throw new Error('ures');
          // a Dawn beúszó animációja az új kártyákon ne induljon (a figyelője csak az első betöltéskor fut)
          uj.forEach((li) => { if (li.classList.contains('scroll-trigger')) li.classList.add('scroll-trigger--cancel'); });
          ul.append(...uj);
          elso = uj[0];
          n += 1;
          const k = kovetkezo(doc);
          url = k ? k.getAttribute('href') : null;
          live.textContent = T.kesz.replace('[db]', uj.length);
          irj();
        } catch (e) {
          irj();
          if (T.hiba) { pa.textContent = T.hiba; pa.hidden = false; }
        }
        busy = false;
        btn.removeAttribute('aria-disabled'); btn.removeAttribute('aria-busy');
        return elso;
      };
      btn.addEventListener('click', async () => {
        const elso = await tolt();
        // a Dawn-kártya első címlinkje kép mellett rejtett, ezért a látható címlinkre kerül a fókusz
        const cel = elso && [...elso.querySelectorAll('.card__heading a[href]')].find((x) => x.getClientRects().length);
        if (cel) cel.focus({ preventScroll: true });
      });
      wrap.classList.add('yd-tobb-rejt');
      wrap.after(d);
      irj();
      cur = { d, tolt, n: () => n, van: () => !!url };
      return cur;
    };
    const visszaallit = async (x) => {
      let m = null;
      try { m = JSON.parse(sessionStorage.getItem(kulcs()) || 'null'); } catch (e) {}
      const nav = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
      if (!x || !m || !(m.n > 1) || !nav || nav.type !== 'back_forward') return;
      while (x.n() < m.n && x.van()) { if (!(await x.tolt())) break; }
      window.scrollTo(0, m.y || 0);
    };
    const indit = () => {
      visszaallit(epit());
      const box = document.getElementById('ProductGridContainer');
      if (box) new MutationObserver(() => epit()).observe(box, { childList: true });
      window.addEventListener('pagehide', () => {
        try {
          if (cur && cur.n() > 1) sessionStorage.setItem(kulcs(), JSON.stringify({ n: cur.n(), y: Math.round(window.scrollY) }));
          else sessionStorage.removeItem(kulcs());
        } catch (e) {}
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', indit, { once: true });
    else indit();
  };

  class YdAlap extends HTMLElement {
    connectedCallback() {
      const SZ = this.dataset.szivek === '1', TR = this.dataset.trim === '1';
      const SHOP = (this.dataset.shop || '').trim();
      if (this._mo) return;
      const FK = 'yd-kedvencek';
      const tpl = this.querySelector('template');
      const HEART = tpl ? tpl.innerHTML : '';
      const LABEL = this.dataset.cimke || 'Kedvencekhez';
      const get = () => { try { const v = JSON.parse(localStorage.getItem(FK) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } };
      const set = (a) => { try { localStorage.setItem(FK, JSON.stringify(a)); } catch (e) {} document.dispatchEvent(new CustomEvent('yd:kedvencek')); };
      const key = (u) => { try { return new URL(u, location.origin).pathname; } catch (e) { return u; } };
      const txt = (el) => (el ? el.textContent.replace(/\s+/g, ' ').trim() : '');
      const data = (w) => {
        const a = [...w.querySelectorAll('.card__heading a[href]')].pop();
        if (!a) return null;
        const im = w.querySelector('.card__media img');
        const sale = w.querySelector('.price--on-sale');
        const pr = sale ? w.querySelector('.price-item--sale') : w.querySelector('.price__regular .price-item--regular');
        return { u: key(a.getAttribute('href')), t: txt(a), i: im ? im.getAttribute('src') || '' : '', p: txt(pr), b: txt(w.querySelector('.card-information > .caption-with-letter-spacing')) };
      };
      const sync = () => {
        const s = new Set(get().map((x) => x.u));
        document.querySelectorAll('.yd-sziv').forEach((b) => b.setAttribute('aria-pressed', String(s.has(b.dataset.u))));
      };
      const trim = (w) => {
        if (w.dataset.ydTrim) return;
        w.dataset.ydTrim = '1';
        const vd = w.querySelector('.card-information > .caption-with-letter-spacing');
        if (!vd) return;
        const full = txt(vd), first = full.split(',')[0].trim();
        if (SHOP && full === SHOP) { const sr = vd.previousElementSibling; if (sr && sr.classList.contains('visually-hidden')) sr.remove(); vd.remove(); return; }
        if (!full) return;
        // A gyártósorban a "Disney " előtag nem kell (a Dawn kártyáján is, mint a saját kártyákon).
        vd.textContent = (TR ? first : full).replace(/^Disney\s+(?=\S)/, '');
        if (!TR) return;
        w.querySelectorAll('.card__heading a').forEach((a) => {
          const t = txt(a);
          for (const b of [full, first]) {
            if (b && t.indexOf(b) === 0 && t.length > b.length + 2) { a.textContent = t.slice(b.length).replace(/^[\s,.:-]+/, ''); break; }
          }
        });
      };
      // A termékszámláló ("1148 termék") ne törjön a szám és a szó között: a Dawn fordítása sima szóközt ad.
      const nbsp = () => {
        document.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach((el) => {
          const tw = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
          for (let n = tw.nextNode(); n; n = tw.nextNode()) {
            const t = n.nodeValue.replace(/(\d)[ \t]+(?=\S)/g, '$1 ');
            if (t !== n.nodeValue) n.nodeValue = t;
          }
        });
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', nbsp, { once: true });
      const scan = () => {
        nbsp();
        const s = new Set(get().map((x) => x.u));
        document.querySelectorAll('.card-wrapper').forEach((w) => {
          trim(w);
          if (!SZ || w.querySelector(':scope > .yd-sziv')) return;
          const d = data(w);
          if (!d) return;
          const b = document.createElement('button');
          b.type = 'button'; b.className = 'yd-sziv'; b.dataset.u = d.u;
          b.setAttribute('aria-label', LABEL + ': ' + d.t);
          b.setAttribute('aria-pressed', String(s.has(d.u)));
          b.innerHTML = HEART;
          w.append(b);
        });
      };
      this._click = (e) => {
        const b = e.target.closest('.yd-sziv');
        if (!b) return;
        e.preventDefault(); e.stopPropagation();
        const w = b.closest('.card-wrapper'), d = w && data(w);
        if (!d) return;
        const a = get(), i = a.findIndex((x) => x.u === d.u);
        if (i > -1) a.splice(i, 1); else a.unshift(d);
        set(a.slice(0, 60));
        b.classList.remove('pop'); void b.offsetWidth; b.classList.add('pop');
      };
      this._sync = sync;
      this._store = (e) => { if (e.key === FK) sync(); };
      document.addEventListener('click', this._click);
      document.addEventListener('yd:kedvencek', sync);
      window.addEventListener('storage', this._store);
      let raf = 0;
      const hit = (n) => n.nodeType === 1 && (n.matches('.card-wrapper') || !!n.querySelector('.card-wrapper'));
      this._mo = new MutationObserver((rs) => {
        if (raf || !rs.some((r) => [...r.addedNodes].some(hit))) return;
        raf = requestAnimationFrame(() => { raf = 0; scan(); });
      });
      this._mo.observe(document.body, { childList: true, subtree: true });
      scan();
      if (this.dataset.tobb === '1' && !window.ydTobbFut) { window.ydTobbFut = true; ydTobb(this); }
    }

    disconnectedCallback() {
      if (this._mo) this._mo.disconnect();
      this._mo = null;
      document.removeEventListener('click', this._click);
      document.removeEventListener('yd:kedvencek', this._sync);
      window.removeEventListener('storage', this._store);
    }
  }
  customElements.define('yd-alap', YdAlap);
}
/* Dawn kosárfiók (cart drawer) a saját szekciók kosárba tételéhez: window.ydFiok.szekciok() a kérésbe kéri a fiók szekcióit,
   window.ydFiok.nyit(valasz) a Dawn renderContents()-ével kirajzolja és megnyitja. A fiókban állított darabszám és törlés után
   (Dawn cartUpdate esemény) az ajándékcsomagolás szinkronja: a csomagolás-sor darabszáma követi a termékét (közös _yd_csomag kulcs),
   az árva csomagolás törlődik, a csomagolás nélkül maradt termékről a jelzés lekerül; a fejléc darabszáma is frissül. */
if (!window.ydFiok) {
  const CSOMAG = 'ajandekcsomagolas';
  const fiok = () => { const d = document.querySelector('cart-drawer'); return d && typeof d.renderContents === 'function' ? d : null; };
  window.ydFiok = {
    szekciok() { const d = fiok(); return d ? { sections: d.getSectionsToRender().map((s) => s.id), sections_url: location.pathname } : {}; },
    nyit(valasz) {
      const d = fiok();
      if (!d || !valasz || !valasz.sections) return false;
      d.classList.remove('is-empty');
      try { d.renderContents(valasz); return true; } catch (e) { return false; }
    }
  };
  const R = (k, alap) => ((window.routes && window.routes[k]) || alap);
  let kor = 0, fut = false;
  const javit = async (cart) => {
    if (fut || !cart || !cart.items) return;
    const fo = {}, cs = [];
    cart.items.forEach((it) => { const t = (it.properties && it.properties._yd_csomag) || ''; if (it.handle === CSOMAG) cs.push({ it, t }); else if (t) fo[t] = it; });
    const upd = {};
    cs.forEach(({ it, t }) => { const m = t ? fo[t] : null, kell = m ? m.quantity : 0; if (kell !== it.quantity) upd[it.key] = kell; });
    const van = new Set(cs.map((w) => w.t));
    const arva = Object.keys(fo).filter((t) => !van.has(t)).map((t) => fo[t]);
    if (!Object.keys(upd).length && !arva.length) { kor = 0; return; }
    if (++kor > 4) return;
    fut = true;
    let j = null;
    try {
      const H = { 'Content-Type': 'application/json', Accept: 'application/json' };
      let res;
      if (Object.keys(upd).length) {
        res = await fetch(R('cart_update_url', '/cart/update') + '.js', { method: 'POST', headers: H, body: JSON.stringify(Object.assign({ updates: upd }, window.ydFiok.szekciok())) });
      } else {
        const m = arva[0], pr = {};
        Object.keys(m.properties || {}).forEach((k) => { pr[k] = ''; });
        res = await fetch(R('cart_change_url', '/cart/change') + '.js', { method: 'POST', headers: H, body: JSON.stringify(Object.assign({ id: m.key, quantity: m.quantity, properties: pr }, window.ydFiok.szekciok())) });
      }
      j = await res.json();
      if (!res.ok) j = null;
    } catch (e) { j = null; }
    fut = false;
    if (!j) return;
    if (j.sections) window.ydFiok.nyit(j);
    if (typeof j.item_count === 'number') document.dispatchEvent(new CustomEvent('yodlo:kosar', { detail: { item_count: j.item_count } }));
    javit(j);
  };
  const feliratkoz = () => {
    /* a Dawn pubsub.js és constants.js felső szintű függvénye és const-ja: csak csupasz névvel érhető el, window-on nem */
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
      if (!e || !e.cartData) return;
      if (typeof e.cartData.item_count === 'number') document.dispatchEvent(new CustomEvent('yodlo:kosar', { detail: { item_count: e.cartData.item_count } }));
      if (e.cartData.items) javit(e.cartData);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', feliratkoz, { once: true }); else feliratkoz();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yodlo-fejlec"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('yd-fejlec')) {
  class YdFejlec extends HTMLElement {
    connectedCallback() {
      if (this._ac) return;
      const ac = (this._ac = new AbortController());
      const sig = { signal: ac.signal };
      const $ = (s) => this.querySelector(s);
      const $$ = (s) => [...this.querySelectorAll(s)];
      const R = document.documentElement;
      const RM = matchMedia('(prefers-reduced-motion: reduce)');
      const still = () => RM.matches;
      const DESK = matchMedia('(min-width:1200px)');
      const NAR = matchMedia('(max-width:1199px)');
      const H = $('.fa-hdr'), ann = $('.fa-ann'), L = $('.fa-logo'), crow = $('.fa-crow'), cs = $('.fa-cs');
      const so = $('.fa-so'), dr = $('.fa-dr'), fav = $('.fa-favp'), q = $('.fa-q'), q2 = $('.fa-q2');
      const tpl = $('template.fa-ics');
      const IC = {};
      if (tpl) tpl.content.querySelectorAll('[data-i]').forEach((s) => { IC[s.dataset.i] = s.outerHTML; });
      const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
      const SUG = this.dataset.suggest || '/search/suggest';
      const SRCH = this.dataset.search || '/search';
      const CART = this.dataset.cart || '/cart';
      const sUrl = (v) => SRCH + '?q=' + encodeURIComponent(v) + '&options%5Bprefix%5D=last';

      /* penzformatum a bolt beallitasabol */
      const MF = (this.dataset.money || '\x7b\x7bamount\x7d\x7d').replace(/<[^>]*>/g, '');
      const MRE = new RegExp('\\x7b\\x7b\\s*(\\w+)\\s*\\x7d\\x7d');
      const fmt = (c, d, t, s) => { const x = (c / 100).toFixed(d).split('.'); const a = x[0].replace(/\B(?=(\d{3})+(?!\d))/g, t); return x[1] ? a + s + x[1] : a; };
      const money = (c) => MF.replace(MRE,(m, k) => ({
        amount: fmt(c, 2, ',', '.'), amount_no_decimals: fmt(c, 0, ',', '.'),
        amount_with_comma_separator: fmt(c, 2, '.', ','), amount_no_decimals_with_comma_separator: fmt(c, 0, '.', ','),
        amount_with_space_separator: fmt(c, 2, ' ', ','), amount_no_decimals_with_space_separator: fmt(c, 0, ' ', ','),
        amount_with_apostrophe_separator: fmt(c, 2, "'", '.')
      })[k] || fmt(c, 2, ',', '.')).replace(/ /g, ' ');

      /* marquee: erintesre megall */
      if (cs) {
        let t = 0;
        const hold = () => { clearTimeout(t); cs.classList.add('hold'); };
        const rel = () => { clearTimeout(t); t = setTimeout(() => cs.classList.remove('hold'), 2500); };
        cs.addEventListener('touchstart', hold, { passive: true, signal: ac.signal });
        cs.addEventListener('touchend', rel, sig);
        cs.addEventListener('touchcancel', rel, sig);
      }

      /* tapadas es osszehuzas, hiszterezissel */
      let st = false;
      const annH = () => (ann ? ann.offsetHeight : 0);
      const boing = () => { if (still() || !L) return; L.classList.remove('boing'); void L.offsetWidth; L.classList.add('boing'); };
      if (L) L.addEventListener('animationend', (e) => { if (e.animationName === 'faBoing') L.classList.remove('boing'); }, sig);
      const chk = () => {
        const y = scrollY - annH();
        if (!st && y > 40) { st = true; H.classList.add('stuck'); boing(); }
        else if (st && y < 4) { st = false; H.classList.remove('stuck'); }
      };
      const vt = () => H.style.setProperty('--vt', Math.round(H.getBoundingClientRect().bottom) + 'px');

      /* elbujo fejlec mobilon es tableten */
      let ly = scrollY, acc = 0;
      const hide = (h) => {
        if (!crow) return;
        if (h && !H.classList.contains('hid')) H.style.setProperty('--fa-h1', crow.offsetTop - 8 + 'px');
        H.classList.toggle('hid', h);
      };
      const hs = () => {
        const y = scrollY, d = y - ly; ly = y;
        if (!NAR.matches) { hide(false); return; }
        if (R.classList.contains('yd-lock') || document.activeElement === q) return;
        if (y < annH() + H.offsetHeight) { hide(false); acc = 0; return; }
        acc = (d > 0) === (acc > 0) ? acc + d : d;
        if (acc > 28) hide(true); else if (acc < -14) hide(false);
      };
      H.addEventListener('transitionend', () => { if (H.classList.contains('hid') && crow) H.style.setProperty('--fa-h1', crow.offsetTop - 8 + 'px'); }, sig);
      let raf = 0;
      addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; chk(); vt(); hs(); if (fav && !fav.hidden) favPlace(favAnchor); }); }, { passive: true, signal: ac.signal });
      addEventListener('resize', () => { chk(); vt(); if (!NAR.matches) hide(false); if (fav && !fav.hidden) favPlace(favAnchor); }, sig);
      H.addEventListener('mouseover', vt, sig);
      H.addEventListener('focusin', () => setTimeout(vt, 40), sig);
      chk(); vt();

      /* ertesitosav: valtakozo uzenetek, egerre megallnak */
      const ms = $$('.fa-msg');
      let mi = 0, mhold = false;
      ms.forEach((m, k) => { m.inert = k > 0; });
      if (ann) {
        ann.addEventListener('mouseenter', () => (mhold = true), sig);
        ann.addEventListener('mouseleave', () => (mhold = false), sig);
        ann.addEventListener('focusin', () => (mhold = true), sig);
        ann.addEventListener('focusout', () => (mhold = false), sig);
      }
      if (ms.length > 1) {
        this._iv = setInterval(() => {
          if (mhold || document.hidden) return;
          const a = ms[mi]; a.classList.remove('on'); a.classList.add('out'); a.setAttribute('aria-hidden', 'true'); a.inert = true;
          mi = (mi + 1) % ms.length;
          const b = ms[mi]; b.classList.remove('out'); b.removeAttribute('aria-hidden'); b.inert = false; void b.offsetWidth; b.classList.add('on');
          setTimeout(() => a.classList.remove('out'), 650);
        }, 4200);
      }

      /* logomatrica: a mutato fele billen */
      if (L && matchMedia('(hover:hover)').matches) {
        L.addEventListener('pointermove', (e) => {
          if (still()) return;
          const r = L.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
          L.classList.add('tilt');
          L.style.setProperty('--ry', ((x - 0.5) * 24).toFixed(1) + 'deg');
          L.style.setProperty('--rx', ((0.5 - y) * 24).toFixed(1) + 'deg');
          L.style.setProperty('--sx', Math.round(x * 100) + '%');
          L.style.setProperty('--sy', Math.round(y * 100) + '%');
        }, sig);
        L.addEventListener('pointerleave', () => { L.classList.remove('tilt'); L.style.removeProperty('--rx'); L.style.removeProperty('--ry'); }, sig);
      }

      /* gepelo helyorzo */
      const ph = $('.fa-ph'), pb = ph && ph.querySelector('b');
      const phSync = () => { if (ph) ph.classList.toggle('off', !!(q && q.value)); };
      if (ph && q && !still()) {
        let names = [];
        try { names = JSON.parse(ph.dataset.names || '[]').map((s) => String(s).trim()).filter(Boolean); } catch (e) { names = []; }
        if (names.length) {
          let n = 0, c = 0, dir = 1;
          q.removeAttribute('placeholder'); ph.hidden = false; phSync();
          const tick = () => {
            if (!this.isConnected) return;
            let d = dir > 0 ? 75 : 32;
            if (!document.hidden) {
              const w = names[n]; c += dir; pb.textContent = w.slice(0, c);
              if (dir > 0 && c >= w.length) { dir = -1; d = 1700; }
              else if (dir < 0 && c <= 0) { dir = 1; n = (n + 1) % names.length; d = 380; }
            }
            this._ph = setTimeout(tick, d);
          };
          this._ph = setTimeout(tick, 900);
          q.addEventListener('input', phSync, sig);
        }
      }

      /* keresojavaslat a Shopify vegpontjarol */
      let sugCtl = null;
      const fetchSug = async (term) => {
        if (sugCtl) sugCtl.abort();
        sugCtl = new AbortController();
        const u = SUG + '.json?q=' + encodeURIComponent(term) + '&resources%5Btype%5D=product,collection&resources%5Blimit%5D=6';
        const r = await fetch(u, { signal: sugCtl.signal, headers: { Accept: 'application/json' } });
        if (!r.ok) throw new Error('suggest');
        const j = await r.json();
        const res = (j.resources && j.resources.results) || {};
        return { p: res.products || [], c: res.collections || [] };
      };
      const imgU = (u, w) => (u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : '');
      const SHOP = this.dataset.shop || '', NOIMG = this.dataset.noimg || '';
      const phImg = () => '<span class="fa-noimg"><span class="fa-noimg-c">' + (IC.box || '') + '</span><span class="fa-noimg-t">' + esc(NOIMG) + '</span></span>';
      const vend = (v) => { v = String(v || '').trim(); return v && v !== SHOP ? v.split(',')[0].trim().replace(/^Disney\s+(?=\S)/, '') : ''; };
      const pimg = (p) => p.image || (p.featured_image && p.featured_image.url) || '';
      const mcard = (p, k) => {
        const pr = Math.round(parseFloat(p.price || 0) * 100), cp = Math.round(parseFloat(p.compare_at_price_max || 0) * 100), sale = cp > pr, im = pimg(p);
        return '<a class="fa-mc" style="--i:' + k + '" href="' + esc(p.url) + '"><span class="fa-mci">' +
          (sale ? '<span class="fa-off">-' + Math.round(((cp - pr) / cp) * 100) + '%</span>' : '') +
          (im ? '<img src="' + esc(imgU(im, 160)) + '" alt="' + esc(p.title) + '" loading="lazy" width="64" height="64">' : phImg()) +
          '</span><span class="fa-mct"><span class="fa-mcb">' + esc(vend(p.vendor)) + '</span><span class="fa-mcn">' + esc(p.title) + '</span>' +
          (sale ? '<span class="fa-mcp sale">' + money(pr) + '<s>' + money(cp) + '</s></span>' : '<span class="fa-mcp">' + money(pr) + '</span>') + '</span></a>';
      };
      const cchip = (c, k) => {
        const im = (c.featured_image && c.featured_image.url) || c.image || '';
        return '<a class="fa-sc' + (im ? '' : ' noimg') + '" style="--i:' + k + '" href="' + esc(c.url) + '">' + (im ? '<img src="' + esc(imgU(im, 80)) + '" alt="" loading="lazy" width="30" height="30">' : '') + esc(c.title) + '</a>';
      };
      const liveHtml = (v, r) =>
        (r.c.length ? '<p class="fa-sh">' + (IC.trend || '') + '<span>Gyűjtemények</span></p><div class="fa-schips">' + r.c.map(cchip).join('') + '</div>' : '') +
        (r.p.length ? '<p class="fa-sh">' + (IC.flame || '') + '<span>Termékek</span></p><div class="fa-sprods">' + r.p.map((p, k) => mcard(p, k + r.c.length)).join('') + '</div>' : '');
      const sug0 = $('.fa-sug0'), sug1 = $('.fa-sug1');
      const NONE = this.dataset.none || '';
      let tq = 0;
      if (q && sug1) {
        q.addEventListener('input', () => {
          clearTimeout(tq);
          const v = q.value.trim();
          if (!v) { sug1.hidden = true; sug1.innerHTML = ''; if (sug0) sug0.hidden = false; return; }
          tq = setTimeout(async () => {
            let r = { p: [], c: [] };
            try { r = await fetchSug(v); } catch (e) { if (e && e.name === 'AbortError') return; }
            if (q.value.trim() !== v) return;
            const body = liveHtml(v, r);
            sug1.innerHTML = (body || '<p class="fa-snone">' + esc(NONE) + '</p>') +
              '<a class="fa-sall" href="' + esc(sUrl(v)) + '"><span>Összes találat:</span><b>„' + esc(v) + '”</b>' + (IC.arrow || '') + '</a>';
            sug1.hidden = false; if (sug0) sug0.hidden = true;
          }, 220);
        }, sig);
      }

      /* kosarjelveny, konfetti, repulo kep */
      const fx = document.createElement('div');
      fx.className = 'fa-fx'; fx.setAttribute('aria-hidden', 'true');
      this.append(fx);
      const STAR = $('.fa-spk') ? $('.fa-spk').innerHTML : '';
      const CC = ['var(--red)', 'var(--yellow)', 'var(--green)', 'var(--blue)', 'var(--sun)'];
      const cartTarget = () => {
        const c = [$('.fa-acts .fa-cart'), $('.fa-mini-c'), $('.fa-bn [data-k="kosar"]')];
        for (const x of c) { if (!x) continue; const r = x.getBoundingClientRect(); if (r.width && r.bottom > 0 && r.top < innerHeight) return x; }
        return c[0];
      };
      const burst = () => {
        if (still()) return;
        const cb = cartTarget(); if (!cb) return;
        const r = cb.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height / 2;
        for (let k = 0; k < 18; k++) {
          const s = document.createElement('span'), star = k % 4 === 0;
          s.className = 'fa-cf' + (star ? ' st' : '');
          if (star) { s.innerHTML = STAR; s.style.color = CC[k % 5]; } else s.style.background = CC[k % 5];
          s.style.left = cx + 'px'; s.style.top = cy + 'px'; fx.append(s);
          const a = Math.PI * (1.05 + Math.random() * 0.9) + (k % 2 ? 0 : Math.PI * 0.9 * Math.random()), d = 38 + Math.random() * 52;
          const dx = Math.cos(a) * d, dy = Math.sin(a) * d, rot = (Math.random() * 2 - 1) * 260;
          s.animate([
            { transform: 'translate(-50%,-50%) scale(.3)', opacity: 1 },
            { transform: 'translate(calc(-50% + ' + dx + 'px),calc(-50% + ' + dy + 'px)) rotate(' + rot * 0.6 + 'deg) scale(1)', opacity: 1, offset: 0.45 },
            { transform: 'translate(calc(-50% + ' + dx * 1.25 + 'px),calc(-50% + ' + (dy + 46) + 'px)) rotate(' + rot + 'deg) scale(.7)', opacity: 0 }
          ], { duration: 900 + Math.random() * 350, easing: 'cubic-bezier(.2,.7,.35,1)' }).onfinish = () => s.remove();
        }
      };
      const cartEls = () => $$('[data-yd-cartn]');
      let last = parseInt((cartEls()[0] || {}).textContent, 10) || 0, land = 0;
      const setCount = (n) => {
        n = parseInt(n, 10) || 0;
        const ch = n !== last, up = n > last; last = n;
        cartEls().forEach((x) => { x.textContent = n > 0 ? n : ''; });
        const ca = $('.fa-acts .fa-cart'); if (ca) ca.setAttribute('aria-label', 'Kosár, ' + n + ' termék');
        if (!ch) return;
        setTimeout(() => {
          [...cartEls(), ca].forEach((x) => { if (!x) return; x.classList.remove('pop'); void x.offsetWidth; x.classList.add('pop'); });
          if (up) burst();
        }, Math.max(0, land - performance.now()));
      };
      const refresh = () => fetch(CART + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((c) => setCount(c.item_count)).catch(() => {});
      const cib = this.querySelector('#cart-icon-bubble');
      if (cib) { this._mo = new MutationObserver(refresh); this._mo.observe(cib, { childList: true, subtree: true }); }
      const sub = () => { if (!this._unsub && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') this._unsub = subscribe(PUB_SUB_EVENTS.cartUpdate, refresh); };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sub, { once: true, signal: ac.signal }); else sub();
      addEventListener('pageshow', (e) => { if (e.persisted) refresh(); }, sig);
      document.addEventListener('yodlo:kosar', (e) => {
        const n = e.detail && e.detail.item_count;
        if (n === undefined || n === null || isNaN(parseInt(n, 10))) refresh(); else setCount(n);
      }, sig);
      const fly = (img) => {
        const cb = cartTarget(); if (!cb) return;
        const a = img.getBoundingClientRect(), c = cb.getBoundingClientRect();
        if (!a.width || a.bottom < 0 || a.top > innerHeight) return;
        const s = Math.min(a.width, a.height, 150), x0 = a.left + a.width / 2 - s / 2, y0 = a.top + a.height / 2 - s / 2;
        const dx = c.left + c.width / 2 - (x0 + s / 2), dy = c.top + c.height / 2 - (y0 + s / 2);
        const o = document.createElement('span'); o.className = 'fa-fly'; o.style.cssText = 'left:' + x0 + 'px;top:' + y0 + 'px;width:' + s + 'px;height:' + s + 'px';
        const im = document.createElement('img'); im.src = img.currentSrc || img.src; im.alt = ''; o.append(im); fx.append(o);
        const D = 880; land = performance.now() + D - 40;
        o.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(' + dx + 'px)' }], { duration: D, easing: 'cubic-bezier(.45,0,.7,1)', fill: 'forwards' });
        const k = Math.max(0.12, 26 / s);
        im.animate([
          { transform: 'translateY(0) scale(1) rotate(0)', opacity: 1 },
          { transform: 'translateY(' + dy * 0.62 + 'px) scale(' + Math.max(k, 0.62) + ') rotate(-10deg)', opacity: 1, offset: 0.5 },
          { transform: 'translateY(' + dy + 'px) scale(' + k + ') rotate(-24deg)', opacity: 0.8 }
        ], { duration: D, easing: 'cubic-bezier(.25,.8,.4,1)', fill: 'forwards' }).onfinish = () => o.remove();
      };
      document.addEventListener('click', (e) => {
        if (still()) return;
        const b = e.target.closest('.quick-add__submit,.product-form__submit');
        if (!b || b.disabled || b.getAttribute('aria-disabled') === 'true' || b.closest('modal-opener')) return;
        const box = b.closest('.card-wrapper,.quick-add-modal__content,product-info,.product');
        const img = box && box.querySelector('.card__media img,.product__media-item.is-active img,.product__media img,img');
        if (img) fly(img);
      }, { capture: true, signal: ac.signal });

      /* kedvencek: helyben tarolt lista */
      const FK = 'yd-kedvencek';
      const favGet = () => { try { const v = JSON.parse(localStorage.getItem(FK) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } };
      const favSet = (a) => { try { localStorage.setItem(FK, JSON.stringify(a)); } catch (e) {} document.dispatchEvent(new CustomEvent('yd:kedvencek')); };
      const favRender = () => {
        const a = favGet();
        $$('[data-yd-favn]').forEach((b) => { b.textContent = a.length ? a.length : ''; });
        if (!fav) return;
        fav.querySelector('.fa-favl').innerHTML = a.map((x, k) =>
          '<li class="fa-favi"><a class="fa-mc" style="--i:' + k + '" href="' + esc(x.u) + '"><span class="fa-mci">' +
          (x.i ? '<img src="' + esc(x.i) + '" alt="' + esc(x.t) + '" loading="lazy" width="64" height="64">' : phImg()) +
          '</span><span class="fa-mct"><span class="fa-mcb">' + esc(vend(x.b)) + '</span><span class="fa-mcn">' + esc(x.t) + '</span>' +
          (x.p ? '<span class="fa-mcp">' + esc(x.p) + '</span>' : '') + '</span></a>' +
          '<button class="fa-favrm" type="button" data-yd-favrm="' + esc(x.u) + '" aria-label="Törlés a kedvencek közül: ' + esc(x.t) + '">' + (IC.x || '') + '</button></li>').join('');
        fav.querySelector('.fa-fave').hidden = a.length > 0;
      };
      document.addEventListener('yd:kedvencek', favRender, sig);
      addEventListener('storage', (e) => { if (e.key === FK) favRender(); }, sig);
      favRender();
      let favAnchor = null, favBack = null;
      const favPlace = (a) => {
        if (!fav) return;
        const w = fav.offsetWidth, h = fav.offsetHeight, vw = innerWidth, vh = innerHeight;
        let x, y;
        const r = a && a.getBoundingClientRect();
        if (r && r.width && r.bottom > 0) {
          x = Math.max(12, Math.min(r.right - w, vw - w - 12)); y = r.bottom + 10;
          if (y + h > vh - 12) y = Math.max(12, vh - h - 12);
        } else { x = Math.max(12, (vw - w) / 2); y = Math.max(12, (vh - h) / 2); }
        fav.style.left = Math.round(x) + 'px'; fav.style.top = Math.round(y) + 'px';
      };
      const favOpen = (o, a) => {
        if (!fav) return;
        if (!o) {
          if (fav.hidden) return;
          fav.hidden = true;
          $$('[data-yd-fav]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
          if (favBack && favBack.isConnected && favBack.offsetParent !== null) favBack.focus({ preventScroll: true });
          return;
        }
        drOpen(false); soOpen(false);
        favBack = a || document.activeElement;
        favAnchor = a && a.closest('.fa-acts') ? a : null;
        favRender(); fav.hidden = false; favPlace(favAnchor);
        $$('[data-yd-fav]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
        const x = fav.querySelector('.fa-favx'); if (x) x.focus({ preventScroll: true });
      };
      document.addEventListener('click', (e) => {
        if (!fav || fav.hidden) return;
        if (!e.target.isConnected) return;
        if (e.target.closest('.fa-favp,[data-yd-fav]')) return;
        favOpen(false);
      }, sig);

      /* gorgetes-zar nyitott retegnel, also sav kijelolese */
      let back = null;
      const lock = () => R.classList.toggle('yd-lock', !!((so && so.classList.contains('on')) || (dr && dr.classList.contains('on'))));
      const bnSync = () => {
        const k = so && so.classList.contains('on') ? 'kereses' : dr && dr.classList.contains('on') ? 'kat' : this.dataset.bn;
        $$('.fa-bn-i').forEach((b) => {
          const on = b.dataset.k === k; b.classList.toggle('on', on);
          if (on && b.tagName === 'A') b.setAttribute('aria-current', 'page'); else b.removeAttribute('aria-current');
        });
      };

      /* oldalfiok */
      const drOpen = (o) => {
        if (!dr || o === dr.classList.contains('on')) return;
        if (o) { back = document.activeElement; soOpen(false); favOpen(false); }
        dr.classList.toggle('on', o); dr.inert = !o; dr.setAttribute('aria-hidden', String(!o)); lock(); bnSync();
        $$('[data-yd-drawer]').forEach((b) => b.setAttribute('aria-expanded', String(o)));
        if (o) { const x = dr.querySelector('.fa-xb'); if (x) x.focus({ preventScroll: true }); }
        else if (back && back.focus && back.isConnected && !back.closest('.fa-dr')) back.focus({ preventScroll: true });
      };
      if (dr) {
        dr.querySelectorAll('details').forEach((d) => d.addEventListener('toggle', () => {
          if (!d.open) return;
          dr.querySelectorAll('details[open]').forEach((x) => { if (x !== d) x.open = false; });
          setTimeout(() => d.scrollIntoView({ block: 'nearest', behavior: still() ? 'auto' : 'smooth' }), 80);
        }, sig));
        const di = dr.querySelector('.fa-drin');
        let sx = 0, sy = 0, dx = 0, drag = 0;
        di.addEventListener('touchstart', (e) => { const t = e.touches[0]; sx = t.clientX; sy = t.clientY; dx = 0; drag = 0; }, { passive: true, signal: ac.signal });
        di.addEventListener('touchmove', (e) => {
          const t = e.touches[0], x = t.clientX - sx, y = t.clientY - sy;
          if (!drag) { if (x < -12 && Math.abs(x) > Math.abs(y) * 1.4) drag = 1; else if (Math.abs(y) > 10 || x > 12) drag = -1; }
          if (drag === 1) { dx = Math.min(0, x + 12); dr.classList.add('drag'); di.style.transform = 'translateX(' + dx + 'px)'; }
        }, { passive: true, signal: ac.signal });
        const tend = () => { if (drag === 1) { dr.classList.remove('drag'); di.style.transform = ''; if (dx < -80) drOpen(false); } drag = 0; };
        di.addEventListener('touchend', tend, sig);
        di.addEventListener('touchcancel', tend, sig);
      }

      /* teljes kepernyos kereso */
      const sg = $('.fa-sogo'), gl = sg && sg.querySelector('b'), tiles = $$('.fa-sot'), pops = $$('.fa-sopop a'), none = $('.fa-sonone'), solive = $('.fa-solive');
      const nz = (s) => String(s).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
      let t2 = 0;
      const filt = (all) => {
        if (!q2) return;
        const raw = q2.value.trim(), v = all ? '' : nz(raw);
        if (gl) gl.textContent = '„' + raw + '”';
        if (sg) { sg.hidden = !raw; sg.href = sUrl(raw); }
        let n = 0;
        [...tiles, ...pops].forEach((x) => { const h = !!v && !nz(x.dataset.n || '').includes(v); x.hidden = h; if (!h) n++; });
        $$('.fa-sos').forEach((s) => { s.hidden = !!v && !s.querySelector('a:not([hidden])'); });
        clearTimeout(t2);
        if (!raw || all) { if (solive) { solive.hidden = true; solive.innerHTML = ''; } if (none) none.hidden = true; return; }
        t2 = setTimeout(async () => {
          let r = { p: [], c: [] };
          try { r = await fetchSug(raw); } catch (e) { if (e && e.name === 'AbortError') return; }
          if (q2.value.trim() !== raw) return;
          const body = liveHtml(raw, r);
          if (solive) { solive.innerHTML = body; solive.hidden = !body; }
          if (none) none.hidden = n > 0 || !!body;
        }, 220);
      };
      const soOpen = (o) => {
        if (!so || o === so.classList.contains('on')) return;
        if (o) { back = document.activeElement; drOpen(false); favOpen(false); if (q && q2) q2.value = q.value; filt(true); }
        so.classList.toggle('on', o); so.inert = !o; so.setAttribute('aria-hidden', String(!o)); lock(); bnSync();
        $$('[data-yd-so]').forEach((b) => b.setAttribute('aria-expanded', String(o)));
        if (o) { if (q2) { q2.focus({ preventScroll: true }); q2.select(); } }
        else if (back && back.focus && back.isConnected) back.focus({ preventScroll: true });
      };
      if (q2) q2.addEventListener('input', () => filt(), sig);

      this.addEventListener('click', (e) => {
        const t = e.target;
        if (t.closest('[data-yd-drawer]')) { drOpen(true); return; }
        if (t.closest('[data-yd-drclose]') || t === dr) { drOpen(false); return; }
        if (t.closest('[data-yd-so]')) { soOpen(true); return; }
        if (t.closest('.fa-sox')) { soOpen(false); return; }
        const fb = t.closest('[data-yd-fav]');
        if (fb) { favOpen(!fav || fav.hidden, fb); return; }
        if (t.closest('.fa-favx')) { favOpen(false); return; }
        const rm = t.closest('[data-yd-favrm]');
        if (rm) { favSet(favGet().filter((x) => x.u !== rm.dataset.ydFavrm)); const f = fav && fav.querySelector('.fa-favx'); if (f) f.focus({ preventScroll: true }); return; }
        if (DESK.matches && t.closest('.fa-sug a')) setTimeout(() => document.activeElement && document.activeElement.blur(), 0);
      }, sig);
      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        if (so && so.classList.contains('on')) soOpen(false);
        else if (dr && dr.classList.contains('on')) drOpen(false);
        else if (fav && !fav.hidden) favOpen(false);
        else { const a = document.activeElement; if (a && a.closest && a.closest('.fa-sbox,.fa-nav')) a.blur(); }
      }, sig);
      if (so) so.inert = true;
      if (dr) dr.inert = true;
      bnSync();

      /* megamenu: a panel megmeri magat, es nem log ki a kepernyobol */
      $$('.fa-mm').forEach((m) => {
        const p = m.querySelector('.fa-mmp'); if (!p) return;
        const fit = () => requestAnimationFrame(() => {
          p.style.translate = '';
          const r = p.getBoundingClientRect(); if (!r.width) return;
          let dx = 0;
          if (r.right > innerWidth - 16) dx = innerWidth - 16 - r.right;
          if (r.left + dx < 16) dx = 16 - r.left;
          p.style.translate = dx ? dx + 'px 0' : '';
          p.style.maxHeight = Math.max(220, innerHeight - r.top - 16) + 'px';
        });
        m.addEventListener('mouseenter', fit, sig);
        m.addEventListener('focusin', fit, sig);
      });
    }

    disconnectedCallback() {
      if (this._ac) this._ac.abort();
      this._ac = null;
      clearInterval(this._iv);
      clearTimeout(this._ph);
      if (this._mo) this._mo.disconnect();
      if (this._unsub) this._unsub();
      this._unsub = null;
      document.documentElement.classList.remove('yd-lock');
    }
  }
  customElements.define('yd-fejlec', YdFejlec);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yodlo-kosar"]) return;
  try {
    
if (!customElements.get('yd-kosar')) {
  class YdKosar extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', () => { if (this.isConnected) this.init(); }, { once: true }); return; }
      this.init();
    }

    init() {
      if (this._ac) return;
      const ac = (this._ac = new AbortController());
      const sig = { signal: ac.signal };
      const SID = this.dataset.section, CART = this.dataset.cart || '/cart';
      const RECO = this.dataset.reco || '/recommendations/products';
      const MIN = parseInt(this.dataset.min, 10) || 0, MAX = parseInt(this.dataset.max, 10) || 0;
      const ADD = this.dataset.add || '';
      const tpl = this.querySelector('template.yk-ics');
      const icn = (c) => { const x = tpl && tpl.content.querySelector('.' + c); return x ? x.outerHTML : ''; };
      const ICART = icn('yk-ic-cart'), IBOX = icn('yk-ic-box');
      const PICK = this.dataset.pick || '', NOIMG = this.dataset.noimg || '', TOL = this.dataset.tol || '';
      const xs = this.querySelector('.yk-xs'), xg = this.querySelector('.yk-xsg');
      const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
      const MF = (this.dataset.money || '\x7b\x7bamount\x7d\x7d').replace(/<[^>]*>/g, '');
      const MRE = new RegExp('\\x7b\\x7b\\s*(\\w+)\\s*\\x7d\\x7d');
      const fmt = (c, d, t, s) => { const x = (c / 100).toFixed(d).split('.'); const a = x[0].replace(/\B(?=(\d{3})+(?!\d))/g, t); return x[1] ? a + s + x[1] : a; };
      const money = (c) => MF.replace(MRE, (m, k) => ({
        amount: fmt(c, 2, ',', '.'), amount_no_decimals: fmt(c, 0, ',', '.'),
        amount_with_comma_separator: fmt(c, 2, '.', ','), amount_no_decimals_with_comma_separator: fmt(c, 0, '.', ','),
        amount_with_space_separator: fmt(c, 2, ' ', ','), amount_no_decimals_with_space_separator: fmt(c, 0, ' ', ','),
        amount_with_apostrophe_separator: fmt(c, 2, "'", '.')
      })[k] || fmt(c, 2, ',', '.')).replace(/ /g, ' ');
      const root = () => this.querySelector('[data-yk-root]');
      const trimT = (t, v) => {
        t = String(t || ''); v = String(v || '');
        for (const b of [v, v.split(',')[0].trim()]) {
          if (b && t.indexOf(b) === 0 && t.length > b.length + 2) return t.slice(b.length).replace(/^[\s,.:-]+/, '');
        }
        return t;
      };
      const tell = (n) => document.dispatchEvent(new CustomEvent('yodlo:kosar', { detail: { item_count: n } }));

      /* a szekcio ujrarajzolasa a Shopify valaszabol */
      const swap = (sections) => {
        const html = sections && sections[SID];
        if (!html) { location.reload(); return; }
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-yk-root]'), old = root();
        if (!fresh || !old) { location.reload(); return; }
        const a = document.activeElement, key = a && a.closest && a.closest('.yk-ci') ? a.closest('.yk-ci').dataset.key : null;
        const which = a && a.dataset ? (a.dataset.ykQ || (a.tagName === 'INPUT' ? 'in' : '')) : '';
        const pontRegi = old.querySelector('.cart__items'), pont = [];
        for (let n = pontRegi && pontRegi.nextSibling; n && !(n.nodeType === 1 && n.matches('.yk-tot')); n = n.nextSibling) pont.push(n);
        old.replaceWith(fresh);
        /* a PeakShip csomagpontválasztója a .cart__items és a végösszeg között ül; ha a bővítmény nem rakja vissza, áttesszük az új összesítőbe */
        if (pont.length) setTimeout(() => {
          const uj = fresh.querySelector('.cart__items');
          if (!uj || (uj.nextElementSibling && !uj.nextElementSibling.matches('.yk-tot'))) return;
          let ref = uj;
          pont.forEach((n) => { ref.after(n); ref = n; });
        }, 300);
        tell(parseInt(fresh.dataset.count, 10) || 0);
        if (key) {
          const ci = fresh.querySelector('.yk-ci[data-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
          const t = ci && (which === 'in' ? ci.querySelector('input') : ci.querySelector('[data-yk-q="' + which + '"]'));
          if (t) t.focus({ preventScroll: true });
        }
        reco();
        setTimeout(sync, 0);
      };
      let busy = false;
      const change = async (ci, q) => {
        if (busy) return;
        busy = true; ci.classList.add('busy');
        try {
          const r = await fetch(CART + '/change.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line: parseInt(ci.dataset.line, 10), quantity: q, sections: [SID], sections_url: location.pathname })
          });
          const j = await r.json();
          if (!r.ok) throw new Error(j.description || j.message || 'hiba');
          swap(j.sections);
        } catch (e) { location.reload(); }
        finally { busy = false; }
      };
      /* ajándékcsomagolás: a csomagolás-sor darabszáma követi a hozzá tartozó termékét (közös _yd_csomag kulcs); az árva csomagolás
         törlődik, a csomagolás nélkül maradt termékről a jelzés lekerül. Legfeljebb négy javító kör egymás után. */
      let syncN = 0;
      const sync = async () => {
        const r = root();
        if (!r || busy) return;
        const fo = {}, cs = [];
        r.querySelectorAll('.yk-ci[data-tok], .yk-ci[data-wrap]').forEach((ci) => { if (ci.dataset.wrap) cs.push(ci); else fo[ci.dataset.tok] = ci; });
        const upd = {};
        cs.forEach((ci) => { const m = ci.dataset.tok ? fo[ci.dataset.tok] : null, want = m ? parseInt(m.dataset.q, 10) || 0 : 0; if (want !== (parseInt(ci.dataset.q, 10) || 0)) upd[ci.dataset.key] = want; });
        const van = new Set(cs.map((ci) => ci.dataset.tok));
        const arva = Object.keys(fo).filter((tk) => !van.has(tk)).map((tk) => fo[tk]);
        if (!Object.keys(upd).length && !arva.length) { syncN = 0; return; }
        if (++syncN > 4) return;
        busy = true;
        let j = null;
        try {
          const H = { 'Content-Type': 'application/json', Accept: 'application/json' };
          let res;
          if (Object.keys(upd).length) {
            res = await fetch(CART + '/update.js', { method: 'POST', headers: H, body: JSON.stringify({ updates: upd, sections: [SID], sections_url: location.pathname }) });
          } else {
            /* a Liquid json-ja kulcs-érték párok tömbje: [["Ajándékcsomagolás","Igen"],["_yd_csomag","..."]] */
            const ci = arva[0], pr = {};
            let nyers = [];
            try { nyers = JSON.parse(ci.dataset.props || '[]') || []; } catch (e) { nyers = []; }
            (Array.isArray(nyers) ? nyers : Object.entries(nyers)).forEach((x) => { if (x && x[0]) pr[x[0]] = ''; });
            pr._yd_csomag = '';
            res = await fetch(CART + '/change.js', { method: 'POST', headers: H, body: JSON.stringify({ id: ci.dataset.key, quantity: parseInt(ci.dataset.q, 10) || 1, properties: pr, sections: [SID], sections_url: location.pathname }) });
          }
          j = await res.json();
          if (!res.ok) j = null;
        } catch (e) { j = null; }
        busy = false;
        if (j && j.sections) swap(j.sections);
      };
      this.addEventListener('click', (e) => {
        const b = e.target.closest('[data-yk-q]');
        if (b) {
          const ci = b.closest('.yk-ci'), inp = ci.querySelector('input');
          const st = parseInt(ci.dataset.step, 10) || 1, mn = parseInt(ci.dataset.min, 10) || 1;
          let q = (parseInt(inp.value, 10) || 0) + st * parseInt(b.dataset.ykQ, 10);
          if (q > 0 && q < mn) q = parseInt(b.dataset.ykQ, 10) < 0 ? 0 : mn;
          change(ci, Math.max(0, q));
          return;
        }
        const d = e.target.closest('[data-yk-del]');
        if (d) { e.preventDefault(); change(d.closest('.yk-ci'), 0); return; }
        const x = e.target.closest('[data-yk-add]');
        if (x) addReco(x);
      }, sig);
      this.addEventListener('change', (e) => {
        const inp = e.target.closest('.yk-qty input');
        if (!inp) return;
        const v = Math.max(0, parseInt(inp.value, 10) || 0);
        change(inp.closest('.yk-ci'), v);
      }, sig);
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' && e.target.closest('.yk-qty input')) { e.preventDefault(); e.target.blur(); }
      }, sig);

      /* ajanlo: a kosarban levo elso termek ajanlasaibol, a kisebb arsav elore */
      let recoFor = '';
      const reco = async () => {
        const r = root();
        const first = r && r.dataset.first, inCart = new Set(((r && r.dataset.pids) || '').split(',').filter(Boolean).map(String));
        if (!first) { xs.hidden = true; xg.innerHTML = ''; recoFor = ''; return; }
        const keyNow = first + '|' + [...inCart].join(',');
        if (keyNow === recoFor) return;
        recoFor = keyNow;
        try {
          const res = await fetch(RECO + '.json?product_id=' + encodeURIComponent(first) + '&limit=10&intent=related', { headers: { Accept: 'application/json' } });
          const j = await res.json();
          if (recoFor !== keyNow) return;
          const all = (j.products || []).filter((p) => !inCart.has(String(p.id)) && !(p.tags || []).includes('yd-csomagolas') && p.available && p.variants && p.variants.some((v) => v.available));
          const inR = (p) => (!MIN || p.price >= MIN) && (!MAX || p.price <= MAX);
          const pick = all.filter(inR).concat(all.filter((p) => !inR(p))).slice(0, 4);
          xg.innerHTML = pick.map((p, k) => {
            const v = p.variants.find((x) => x.available);
            const multi = p.variants.length > 1;
            const sale = p.compare_at_price > p.price;
            const img = p.featured_image ? (String(p.featured_image).indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
            const src = img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=360' : '';
            const name = trimT(p.title, p.vendor);
            const media = src ? '<img src="' + esc(src) + '" alt="' + esc(name) + '" loading="lazy" width="180" height="180">'
              : '<span class="yk-noimg yk-nc' + (k % 4) + '"><span class="yk-noimg-c">' + IBOX + '</span><span class="yk-noimg-t">' + esc(NOIMG) + '</span></span>';
            const btn = multi
              ? '<a class="yk-xa" href="' + esc(p.url) + '" aria-label="' + esc(PICK + ': ' + name) + '">' + ICART + '<span>' + esc(PICK) + '</span></a>'
              : '<button class="yk-xa" type="button" data-yk-add="' + v.id + '" aria-label="' + esc(ADD + ': ' + name) + '">' + ICART + '<span>' + esc(ADD) + '</span></button>';
            return '<article class="yk-xc"><a class="yk-xi" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + media + '</a>' +
              '<div class="yk-xb"><a class="yk-xn" href="' + esc(p.url) + '">' + esc(name) + '</a><p class="yk-xp">' +
              (sale ? '<b class="sale">' + money(p.price) + '</b><s>' + money(p.compare_at_price) + '</s>' : '<b>' + money(p.price) + (p.price_varies ? esc(TOL) : '') + '</b>') +
              '</p>' + btn + '</div></article>';
          }).join('');
          xs.hidden = !pick.length;
        } catch (e) { xs.hidden = true; }
      };
      const addReco = async (b) => {
        if (b.disabled) return;
        b.disabled = true;
        try {
          const r = await fetch(CART + '/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(b.dataset.ykAdd, 10), quantity: 1 }], sections: [SID], sections_url: location.pathname })
          });
          const j = await r.json();
          if (!r.ok) throw new Error(j.description || 'hiba');
          swap(j.sections);
        } catch (e) { b.disabled = false; }
      };
      reco();
      sync();
    }

    disconnectedCallback() {
      if (this._ac) this._ac.abort();
      this._ac = null;
    }
  }
  customElements.define('yd-kosar', YdKosar);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yodlo-mesehosok"] && !Shopify.designMode) return;
  try {
    
(() => {
  /* mobilon (560 px alatt) a hősök sora magától, körbe-körbe gördül (marquee). A csempék egy klónozott
     másolata adja a végtelen kört; érintésre, egérrel rámutatásra és billentyű-fókuszra megáll, elengedés után
     2,5 mp-cel indul újra. Csökkentett mozgásnál és a témaszerkesztőben nincs mozgás. */
  const mq = matchMedia("(max-width:560px)"), rm = matchMedia("(prefers-reduced-motion: reduce)");
  const SEBESSEG = 32;
  const init = (row) => {
    if (row.dataset.mq || (window.Shopify && Shopify.designMode)) return;
    row.dataset.mq = "1";
    const orig = [...row.children];
    if (orig.length < 2) return;
    let klonok = [], raf = 0, pos = 0, utolso = 0, kor = 0, all = false, lathato = false, ujra = 0;
    const kell = () => mq.matches && !rm.matches;
    const epit = () => {
      if (klonok.length) return;
      klonok = orig.map((t) => {
        const c = t.cloneNode(true);
        c.setAttribute("aria-hidden", "true");
        c.tabIndex = -1;
        c.removeAttribute("data-shopify-editor-block");
        row.appendChild(c);
        return c;
      });
    };
    const bont = () => { klonok.forEach((c) => c.remove()); klonok = []; row.classList.remove("is-marquee"); };
    const mer = () => { if (klonok.length) kor = klonok[0].offsetLeft - orig[0].offsetLeft; };
    const lep = (t) => {
      raf = 0;
      if (!kell() || !lathato || kor <= 0) return;
      const dt = utolso ? Math.min(t - utolso, 64) : 0;
      utolso = t;
      if (!all) {
        pos += (SEBESSEG * dt) / 1000;
        if (pos >= kor) pos -= kor;
        row.scrollLeft = pos;
      }
      raf = requestAnimationFrame(lep);
    };
    const indit = () => { if (!raf && kell() && lathato) { utolso = 0; raf = requestAnimationFrame(lep); } };
    const megall = () => { all = true; clearTimeout(ujra); };
    const elenged = () => {
      clearTimeout(ujra);
      ujra = setTimeout(() => { if (kor > 0) pos = row.scrollLeft % kor; all = false; }, 2500);
    };
    row.addEventListener("touchstart", megall, { passive: true });
    row.addEventListener("touchend", elenged, { passive: true });
    row.addEventListener("touchcancel", elenged, { passive: true });
    row.addEventListener("pointerenter", (e) => { if (e.pointerType === "mouse") megall(); });
    row.addEventListener("pointerleave", (e) => { if (e.pointerType === "mouse") elenged(); });
    row.addEventListener("focusin", megall);
    row.addEventListener("focusout", elenged);
    new IntersectionObserver((es) => {
      lathato = es[0].isIntersecting;
      if (lathato) indit(); else { cancelAnimationFrame(raf); raf = 0; }
    }).observe(row);
    const alkalmaz = () => {
      if (kell()) { epit(); row.classList.add("is-marquee"); mer(); pos = kor > 0 ? row.scrollLeft % kor : 0; indit(); }
      else { cancelAnimationFrame(raf); raf = 0; bont(); }
    };
    mq.addEventListener("change", alkalmaz);
    rm.addEventListener("change", alkalmaz);
    addEventListener("resize", mer);
    alkalmaz();
  };
  const mind = () => document.querySelectorAll(".yd-mh .yd-heroes").forEach(init);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", mind);
  else mind();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yodlo-termeklap"]) return;
  try {
    
(() => {
  if (customElements.get("yd-termeklap")) return;

  const ROOT = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  const FK = "yd-kedvencek";
  const esc = (s) => String(s == null ? "" : s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]);
  const txt = (el) => (el ? el.textContent.replace(/\s+/g, " ").trim() : "");
  const favGet = () => { try { const v = JSON.parse(localStorage.getItem(FK) || "[]"); return Array.isArray(v) ? v : []; } catch (e) { return []; } };
  const favSet = (a) => { try { localStorage.setItem(FK, JSON.stringify(a)); } catch (e) {} document.dispatchEvent(new CustomEvent("yd:kedvencek")); };

  function money(cents, fmt) {
    cents = Math.round(Number(cents) || 0);
    const grp = (n, d, t, s) => {
      const f = (n / 100).toFixed(d).split(".");
      return f[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (f[1] ? s + f[1] : "");
    };
    fmt = fmt || "{" + "{amount_no_decimals_with_space_separator}" + "} Ft";
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      switch (k) {
        case "amount": return grp(cents, 2, ",", ".");
        case "amount_no_decimals": return grp(cents, 0, ",", ".");
        case "amount_with_comma_separator": return grp(cents, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return grp(cents, 0, ".", ",");
        case "amount_with_space_separator": return grp(cents, 2, " ", ",");
        case "amount_no_decimals_with_space_separator": return grp(cents, 0, " ", ",");
        case "amount_with_apostrophe_separator": return grp(cents, 2, "'", ".");
        default: return grp(cents, 0, " ", ",");
      }
    }).replace(/<[^>]*>/g, "").replace(/ (?=\S+$)/, " ");
  }

  function addBD(d, n) {
    d = new Date(d);
    while (n > 0) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w > 0 && w < 6) n--; }
    return d;
  }

  function short(t, vendor) {
    const full = String(vendor || "").trim(), first = full.split(",")[0].trim();
    for (const b of [full, first]) {
      if (b && t.indexOf(b) === 0 && t.length > b.length + 2) {
        const r = t.slice(b.length).replace(/^[\s,]+/, "");
        return r.charAt(0).toUpperCase() + r.slice(1);
      }
    }
    return t;
  }

  async function cartAdd(items) {
    const r = await fetch(ROOT() + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(Object.assign({ items }, window.ydFiok ? window.ydFiok.szekciok() : {}))
    });
    const d = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(d.description || d.message || "");
    const c = await (await fetch(ROOT() + "cart.js", { headers: { Accept: "application/json" } })).json();
    document.dispatchEvent(new CustomEvent("yodlo:kosar", { detail: { item_count: c.item_count } }));
    if (typeof window.publish === "function" && typeof window.PUB_SUB_EVENTS !== "undefined") window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: "yodlo-termeklap", cartData: c });
    if (window.ydFiok) window.ydFiok.nyit(d);
    return c;
  }

  class YdTermeklap extends HTMLElement {
    connectedCallback() {
      if (this._ok) return;
      this._ok = true;
      const $ = (s) => this.querySelector(s), $$ = (s) => [...this.querySelectorAll(s)];
      this.$ = $; this.$$ = $$;
      try { this.V = JSON.parse(($("[data-yd-v]") || {}).textContent || "[]"); } catch (e) { this.V = []; }
      try { this.T = JSON.parse(($("[data-yd-t]") || {}).textContent || "{}"); } catch (e) { this.T = {}; }
      this.fmt = this.dataset.money;
      this.form = $("form.yd-tl-form");
      this.qi = $('input[name="quantity"]');
      const vid = Number(($("[data-vid]") || {}).value);
      this.v = this.V.find((x) => x.id === vid) || this.V[0];
      this.ac = new AbortController();
      const sig = { signal: this.ac.signal };

      this.gallery(sig);
      this.options();
      this.qty();
      this.favInit(sig);
      this.eta();
      this.submit();
      this.stickyBar(sig);
      this.placeDesc(sig);
      this.cart = null;
      this.cartLoad().then(() => { this.ship(); this.bundle(); });
      document.addEventListener("yodlo:kosar", () => this.cartLoad().then(() => { this.ship(); this.bsync(); }), sig);
      const hdr = document.querySelector(".yd-fejlec, sticky-header, header");
      if (hdr) this.style.setProperty("--yd-tl-top", Math.min(220, Math.max(90, hdr.getBoundingClientRect().height + 20)) + "px");
    }
    disconnectedCallback() { if (this.ac) this.ac.abort(); if (this._io) this._io.disconnect(); this._ok = false; }

    /* ---- galéria és nagy nézet ---- */
    gallery(sig) {
      const $ = this.$, $$ = this.$$;
      const track = $(".yd-tl-track");
      if (!track) return;
      this.slides = $$(".yd-tl-slide:not(.yd-tl-ph)");
      this.idx = 0;
      const n = this.slides.length;
      const set = (i, smooth) => {
        if (!n) return;
        this.idx = Math.max(0, Math.min(n - 1, i));
        if (smooth !== undefined) track.scrollTo({ left: this.idx * track.clientWidth, behavior: smooth ? "smooth" : "auto" });
        const c = $(".yd-tl-count"); if (c) c.textContent = `${this.idx + 1} / ${n}`;
        $$(".yd-tl-dots i").forEach((d, k) => d.classList.toggle("on", k === this.idx));
        $$(".yd-tl-thumbs button").forEach((b, k) => b.setAttribute("aria-current", k === this.idx ? "true" : "false"));
      };
      this.setIdx = set;
      let st;
      track.addEventListener("scroll", () => { clearTimeout(st); st = setTimeout(() => { const i = Math.round(track.scrollLeft / track.clientWidth); if (i !== this.idx) set(i); }, 60); }, { passive: true });
      this.addEventListener("click", (e) => {
        const th = e.target.closest(".yd-tl-thumbs [data-i]");
        if (th) { set(+th.dataset.i, true); return; }
        const nv = e.target.closest(".yd-tl-nav");
        if (nv) { set((this.idx + +nv.dataset.step + n) % n, true); return; }
        if (e.target.closest(".yd-tl-zoom") || (n && e.target.closest(".yd-tl-slide"))) this.lbOpen();
      });
      track.addEventListener("keydown", (e) => {
        if (e.key === "ArrowRight" || e.key === "ArrowLeft") { e.preventDefault(); set(this.idx + (e.key === "ArrowRight" ? 1 : -1), true); }
        if (e.key === "Enter" && n) this.lbOpen();
      });
      const fine = matchMedia("(hover:hover) and (pointer:fine)");
      track.addEventListener("mousemove", (e) => {
        if (!fine.matches) return;
        const sl = e.target.closest(".yd-tl-slide"), im = sl && sl.querySelector("img");
        if (!im) return;
        const r = sl.getBoundingClientRect();
        im.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
        im.style.transform = "scale(1.9)";
      });
      track.addEventListener("mouseleave", () => $$(".yd-tl-slide img").forEach((im) => { im.style.transform = ""; }));

      const lb = $(".yd-tl-lb");
      if (!lb) return;
      const show = () => {
        const s = this.slides[this.idx], si = s.querySelector("img");
        let im = lb.querySelector("img");
        if (!im) { im = document.createElement("img"); lb.prepend(im); }
        im.src = s.dataset.full; im.alt = si ? si.alt : "";
        const c = lb.querySelector(".yd-tl-lb-c"); if (c) c.textContent = `${this.idx + 1} / ${n}`;
      };
      this.lbOpen = () => { show(); if (lb.showModal) lb.showModal(); else lb.setAttribute("open", ""); document.documentElement.style.overflow = "hidden"; };
      const step = (d) => { this.idx = (this.idx + d + n) % n; show(); };
      lb.addEventListener("click", (e) => {
        const b = e.target.closest("[data-lb]");
        if (b) { step(+b.dataset.lb); return; }
        if (e.target.closest("[data-lbx]") || e.target === lb) lb.close ? lb.close() : lb.removeAttribute("open");
      });
      lb.addEventListener("close", () => { document.documentElement.style.overflow = ""; set(this.idx, false); });
      lb.addEventListener("keydown", (e) => { if (n > 1 && (e.key === "ArrowRight" || e.key === "ArrowLeft")) step(e.key === "ArrowRight" ? 1 : -1); });
      let tx = null;
      lb.addEventListener("touchstart", (e) => { tx = e.touches[0].clientX; }, { passive: true });
      lb.addEventListener("touchend", (e) => { if (tx === null) return; const d = e.changedTouches[0].clientX - tx; tx = null; if (Math.abs(d) > 50 && n > 1) step(d < 0 ? 1 : -1); });
    }

    /* ---- változatválasztó ---- */
    options() {
      const fs = this.$$(".yd-tl-opt");
      if (!fs.length) return;
      const mark = () => {
        const sel = fs.map((f) => (f.querySelector("input:checked") || {}).value);
        fs.forEach((f, oi) => f.querySelectorAll(".yd-tl-pill").forEach((lab) => {
          const val = lab.querySelector("input").value;
          const ok = this.V.some((x) => x.a && x.o[oi] === val && x.o.every((o, k) => k === oi || o === sel[k]));
          lab.classList.toggle("na", !ok);
        }));
      };
      // A választott érték a csoportcímkében; centis méretnél alatta a kor-megfelelő (európai gyerekméret-tábla, magasság cm -> év).
      const KOR = [[50, 0], [56, 0.1], [62, 0.25], [68, 0.5], [74, 0.75], [80, 1], [86, 1.5], [92, 2], [98, 3], [104, 4], [110, 5], [116, 6], [122, 7], [128, 8], [134, 9], [140, 10], [146, 11], [152, 12], [158, 13], [164, 14], [170, 15], [176, 16]];
      const kora = (cm) => {
        if (!(cm >= 50 && cm <= 176)) return null;
        for (let i = 1; i < KOR.length; i++) { const [h0, a0] = KOR[i - 1], [h1, a1] = KOR[i]; if (cm <= h1) return a0 + ((a1 - a0) * (cm - h0)) / (h1 - h0); }
        return null;
      };
      const info = (f) => {
        const val = ((f.querySelector("input:checked") || {}).value || "").trim();
        const lv = f.querySelector("[data-lblv]");
        if (lv) { lv.hidden = !val; lv.querySelector("b").textContent = val; }
        const h = f.querySelector("[data-kor]");
        if (!h) return;
        const m = val.match(/^(\d{2,3})(?:\s*[\/-]\s*(\d{2,3}))?\s*cm$/i);
        const lo = m ? kora(+m[1]) : null, hi = m ? kora(+(m[2] || m[1])) : null;
        let t = "";
        if (lo !== null && hi !== null) {
          const ho = hi < 2, a = Math.floor(ho ? lo * 12 : lo), b = Math.max(a, Math.round(ho ? hi * 12 : hi));
          t = (ho ? h.dataset.ho : h.dataset.ev) || "";
          t = t.split("[kor]").join(a === b ? String(a) : a + "-" + b).split("[meret]").join(val);
        }
        h.textContent = t;
        h.hidden = !t;
      };
      this.addEventListener("change", (e) => {
        const f = e.target.closest(".yd-tl-opt");
        if (!f) return;
        const sel = fs.map((f) => (f.querySelector("input:checked") || {}).value);
        const v = this.V.find((x) => x.o.every((o, k) => o === sel[k]));
        mark();
        info(f);
        this.setVariant(v || null);
      });
      mark();
      fs.forEach(info);
    }

    setVariant(v) {
      const $ = this.$, $$ = this.$$, T = this.T;
      this.v = v;
      const add = $$("[data-add],[data-baradd]");
      if (!v) {
        add.forEach((b) => { b.disabled = true; const l = b.querySelector("[data-addl]"); if (l) l.textContent = T.elfogyott; });
        return;
      }
      $("[data-vid]").value = v.id;
      const u = new URL(location.href); u.searchParams.set("variant", v.id); history.replaceState(history.state, "", u.toString());
      const sale = v.c > v.p;
      $("[data-price]").innerHTML = sale ? `<span class="yd-tl-now yd-tl-sale">${esc(money(v.p, this.fmt))}</span><s class="yd-tl-old">${esc(money(v.c, this.fmt))}</s>` : `<span class="yd-tl-now">${esc(money(v.p, this.fmt))}</span>`;
      const off = sale ? Math.round((1 - v.p / v.c) * 100) : 0;
      const sv = $("[data-save]");
      sv.hidden = !sale;
      if (sale) sv.querySelector("span").textContent = T.sporol.replace("{osszeg}", money(v.c - v.p, this.fmt)).replace("{szazalek}", off);
      const ob = $(".yd-tl-off"); if (ob) { ob.hidden = !sale; ob.textContent = sale ? `-${off}%` : ""; }
      $$("[data-sku]").forEach((el) => { el.textContent = v.sku; });
      const skuP = $(".yd-tl-sku"); if (skuP) skuP.hidden = !v.sku;
      const row = (k, val) => { const r = $(`[data-row="${k}"]`); if (r) { r.hidden = !val; r.querySelector("dd").textContent = val; } };
      row("sku", v.sku); row("bc", v.bc); row("w", v.w);
      add.forEach((b) => { b.disabled = !v.a; const l = b.querySelector("[data-addl]"); if (l) l.textContent = v.a ? T.kosarba : T.elfogyott; });
      const bp = $("[data-barp]"); if (bp) { bp.className = sale ? "sale" : ""; }
      this.qi.dataset.min = Math.max(1, v.qm || 1);
      this.qi.dataset.max = v.q != null && v.q > 0 ? v.q : 99;
      this.qi.value = this.qi.dataset.min;
      this.stock();
      this.upSum();
      if (v.m != null && this.slides) {
        const i = this.slides.findIndex((s) => s.dataset.mid === String(v.m));
        if (i > -1 && this.setIdx) this.setIdx(i, true);
      }
      this.bsync();
    }

    stock() {
      const v = this.v, T = this.T, p = this.$("[data-stock]");
      if (!p || !v) return;
      const own = this.dataset.sajat === "1";
      let b, hol, cls = "";
      if (!v.a) { b = T.nincs; hol = ""; cls = "out"; }
      else if (own && !v.t) { b = T.keszlet_semleges; hol = ""; cls = "neutral"; }
      else if (own) { b = T.keszlet_sajat; hol = T.hol_sajat; }
      else if (v.q != null && v.q <= 5) { b = T.keves.replace("{n}", v.q); hol = T.hol_kulso; cls = "low"; }
      else { b = T.keszlet_kulso; hol = T.hol_kulso; }
      p.className = "yd-tl-stock" + (cls ? " " + cls : "");
      p.innerHTML = `<span class="yd-tl-dot" aria-hidden="true"></span><span><b>${esc(b)}</b>${hol ? ", " + esc(hol) : ""}</span>`;
      const e = this.$("[data-eta-p]"); if (e) e.hidden = !v.a || !this._eta;
    }

    /* ---- mennyiség és összeg ---- */
    qty() {
      const qi = this.qi;
      if (!qi) return;
      this.addEventListener("click", (e) => {
        const b = e.target.closest(".yd-tl-qty [data-q]");
        if (!b) return;
        qi.value = (parseInt(qi.value, 10) || 1) + +b.dataset.q;
        this.upSum();
      });
      qi.addEventListener("change", () => this.upSum());
      this.upSum();
    }
    upSum() {
      const qi = this.qi, v = this.v;
      if (!qi || !v) return;
      const mn = +qi.dataset.min || 1, mx = +qi.dataset.max || 99;
      let q = parseInt(qi.value, 10) || mn;
      q = Math.max(mn, Math.min(mx, q));
      qi.value = q;
      const tot = money(v.p * q, this.fmt);
      this.$("[data-addsum]").textContent = q > 1 ? tot : "";
      this.$("[data-qsum]").innerHTML = q > 1 ? esc(this.T.qsum).replace("{db}", q).replace("{osszeg}", `<b>${esc(tot)}</b>`) : "";
      const bp = this.$("[data-barp]"); if (bp) bp.textContent = tot;
    }

    /* ---- kedvenc ---- */
    favInit(sig) {
      const b = this.$("[data-fav]");
      if (!b) return;
      const u = this.dataset.url;
      const sync = () => b.setAttribute("aria-pressed", favGet().some((x) => x.u === u) ? "true" : "false");
      b.addEventListener("click", () => {
        const a = favGet(), i = a.findIndex((x) => x.u === u);
        const im = this.$(".yd-tl-slide img");
        const on = i < 0;
        if (on) a.unshift({ u, t: txt(this.$(".yd-tl-h1")), i: im ? im.currentSrc || im.src : "", p: txt(this.$(".yd-tl-now")), b: txt(this.$(".yd-tl-hero span")) });
        else a.splice(i, 1);
        favSet(a.slice(0, 60));
        sync();
        this.say(on ? this.T.fav_be : this.T.fav_ki);
      });
      document.addEventListener("yd:kedvencek", sync, sig);
      window.addEventListener("storage", (e) => { if (e.key === FK) sync(); }, sig);
      sync();
    }
    say(t, err) {
      const m = this.$("[data-msg]");
      if (!m) return;
      m.classList.toggle("err", !!err);
      m.textContent = t || "";
      clearTimeout(this._say);
      this._say = setTimeout(() => { m.textContent = ""; }, err ? 6000 : 2600);
    }

    /* ---- várható kézbesítés ---- */
    eta() {
      const el = this.$("[data-eta]");
      if (!el) return;
      const mon = (this.dataset.honapok || "").split(",").map((s) => s.trim());
      const day = (this.dataset.napok || "").split(",").map((s) => s.trim());
      if (mon.length !== 12 || day.length !== 7) return;
      const fd = (d) => `${mon[d.getMonth()]} ${d.getDate()}., ${day[d.getDay()]}`;
      const now = new Date(), a = addBD(now, +this.dataset.tol || 1), b = addBD(now, +this.dataset.ig || 2);
      el.innerHTML = esc(this.dataset.etaT).replace("{tol}", `<b>${esc(fd(a))}</b>`).replace("{ig}", `<b>${esc(fd(b))}</b>`);
      this._eta = true;
      this.$("[data-eta-p]").hidden = !(this.v && this.v.a);
    }

    /* ---- kosárba tétel ---- */
    submit() {
      if (!this.form) return;
      this.form.addEventListener("submit", (e) => {
        e.preventDefault();
        this.addMain(this.$("[data-add]"));
      });
      const bb = this.$("[data-baradd]");
      if (bb) bb.addEventListener("click", () => this.addMain(bb));
    }
    /* ---- ajándékcsomagolás: bejelölve a fő termék mellé darabonként a csomagolás-termék is a kosárba kerül, közös kulccsal ---- */
    gift(main, q) {
      const g = this.$("[data-gift]"), c = g && g.querySelector("[data-gift-in]");
      if (!c || !c.checked) return null;
      const t = "c" + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
      const vt = this.V.length > 1 && this.v && this.v.o ? " (" + this.v.o.join(" / ") + ")" : "";
      main.properties = { [g.dataset.prop]: g.dataset.igen, _yd_csomag: t };
      return { id: Number(g.dataset.gid), quantity: q, properties: { [g.dataset.termek]: g.dataset.ptitle + vt, _yd_csomag: t } };
    }
    giftReset() { const c = this.$("[data-gift-in]"); if (c) c.checked = false; }
    async addMain(btn) {
      const v = this.v;
      if (!v || !v.a || btn.disabled) return;
      this.upSum();
      const q = parseInt(this.qi.value, 10) || 1;
      const lab = btn.querySelector("[data-addl]");
      btn.disabled = true;
      btn.setAttribute("aria-busy", "true");
      let ok = false;
      try {
        const items = [{ id: v.id, quantity: q }];
        const gw = this.gift(items[0], q);
        if (gw) items.push(gw);
        this.cart = await cartAdd(items);
        if (gw) this.giftReset();
        ok = true;
        this.say(this.T.ok);
        this.ship(); this.bsync();
      } catch (err) {
        this.say([this.T.hiba, err.message].filter(Boolean).join(" "), true);
      }
      btn.removeAttribute("aria-busy");
      btn.classList.add(ok ? "ok" : "err");
      if (ok && lab) lab.textContent = this.T.ok;
      setTimeout(() => { btn.classList.remove("ok", "err"); btn.disabled = !(this.v && this.v.a); if (lab) lab.textContent = this.v && this.v.a ? this.T.kosarba : this.T.elfogyott; }, ok ? 1400 : 1800);
    }

    /* ---- kosár állapota, ingyenes szállítás sáv ---- */
    async cartLoad() {
      try { this.cart = await (await fetch(ROOT() + "cart.js", { headers: { Accept: "application/json" } })).json(); } catch (e) { this.cart = null; }
    }
    ship() {
      const el = this.$("[data-fship]"), lim = +this.dataset.hatar || 0;
      if (!el || !lim || !this.cart) return;
      const t = this.cart.total_price || 0, rem = lim - t, pct = Math.min(100, Math.round((t / lim) * 100)), T = this.T, f = (c) => esc(money(c, this.fmt));
      el.hidden = false;
      el.classList.toggle("done", rem <= 0);
      el.innerHTML = `<p class="yd-tl-fship-t"><span>${rem > 0 ? esc(T.sz_meg).replace("{osszeg}", `<b>${f(rem)}</b>`) : esc(T.sz_kesz)}</span></p>` +
        `<div class="yd-tl-fbar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${rem > 0 ? pct : 100}"><i style="width:${rem > 0 ? pct : 100}%"></i></div>` +
        `<p class="yd-tl-fship-s">${esc(T.sz_most).replace("{kosar}", f(t)).replace("{hatar}", f(lim))}</p>`;
    }

    /* ---- csomagajánlat a termékajánló API-ból ---- */
    async bundle() {
      const box = this.$("[data-bundle]");
      if (!box) return;
      const max = Math.max(1, parseInt(box.dataset.n || "2", 10));
      const get = async (intent) => {
        try {
          const r = await fetch(this.dataset.rec + "&intent=" + intent, { headers: { Accept: "application/json" } });
          if (!r.ok) return [];
          return (await r.json()).products || [];
        } catch (e) { return []; }
      };
      const pid = Number(this.dataset.pid);
      const usable = (p) => p && p.id !== pid && p.available && !(p.tags || []).includes("yd-csomagolas") && (p.variants || []).some((x) => x.available);
      // Csak a kiegészítő (complementary) ajánlás számít; ha nincs, a doboz rejtve marad.
      let list = (await get("complementary")).filter(usable);
      const own = this.dataset.sajat === "1", tag = this.dataset.cimke;
      if (own && tag) list.sort((a, b) => ((b.tags || []).map((t) => t.toLowerCase()).includes(tag) ? 1 : 0) - ((a.tags || []).map((t) => t.toLowerCase()).includes(tag) ? 1 : 0));
      list = list.slice(0, max);
      if (!list.length) return;
      const self = {
        self: true, id: this.v.id, title: txt(this.$(".yd-tl-h1")),
        img: (() => { const i = this.$(".yd-tl-slide img"); return i ? i.currentSrc || i.src : ""; })()
      };
      const vend = (this.$(".yd-tl-hero:not(.own) span") || {}).textContent || "";
      const items = [self, ...list.map((p) => {
        const va = p.variants.find((x) => x.available) || p.variants[0];
        let img = p.featured_image || "";
        if (img) img = (img.startsWith("//") ? "https:" + img : img) + (img.includes("?") ? "&" : "?") + "width=160";
        return { id: va.id, title: short(p.title, p.vendor), url: p.url, img, p: va.price, c: va.compare_at_price || 0, vendor: p.vendor || "" };
      })];
      const T = this.T;
      const hos = T.hos && vend && list.every((p) => (p.vendor || "").split(",")[0].trim() === vend.trim());
      this.$("[data-bt]").textContent = hos ? T.b_cim_hos.replace("{mesehos}", T.hos) : T.b_cim;
      const inCart = new Set(((this.cart && this.cart.items) || []).map((x) => x.variant_id));
      this.B = { items, on: {} };
      items.forEach((q) => { this.B.on[q.id] = q.self || !inCart.has(q.id); });
      this.$("[data-bi]").innerHTML = items.map((q) => {
        const pr = q.self ? "" : (q.c > q.p ? `<b class="sale">${esc(money(q.p, this.fmt))}</b><s>${esc(money(q.c, this.fmt))}</s>` : `<b>${esc(money(q.p, this.fmt))}</b>`);
        const im = q.img ? `<img src="${esc(q.img)}" alt="${esc(q.title)}" loading="lazy">` : `<span class="yd-noimg-c"></span>`;
        const nm = q.self ? `<span class="yd-tl-tn">${esc(q.title)}</span>` : `<a class="yd-tl-tn" href="${esc(q.url)}">${esc(q.title)}</a>`;
        const th = q.self ? `<span class="yd-tl-ti">${im}</span>` : `<a class="yd-tl-ti" href="${esc(q.url)}" tabindex="-1" aria-hidden="true">${im}</a>`;
        return `<div class="yd-tl-t" data-b="${q.id}"><label class="yd-tl-ck"><input type="checkbox" aria-label="${esc(T.b_input.replace("{termek}", q.title))}"></label>${th}<div class="yd-tl-tb"><span class="yd-tl-tag" hidden></span>${nm}<p class="yd-tl-tp" data-tp>${pr}</p></div></div>`;
      }).join("");
      box.hidden = false;
      this.$("[data-bi]").addEventListener("change", (e) => {
        const t = e.target.closest(".yd-tl-t");
        if (!t) return;
        this.B.on[t.dataset.b] = e.target.checked;
        this.bsync();
      });
      this.$("[data-badd]").addEventListener("click", (e) => this.baddAll(e.currentTarget));
      this.bsync();
    }
    bsync() {
      const B = this.B;
      if (!B) return;
      const T = this.T, $$ = this.$$;
      if (this.v) B.items[0].id = this.v.id, B.items[0].p = this.v.p, B.items[0].c = this.v.c;
      const inCart = new Set(((this.cart && this.cart.items) || []).map((x) => x.variant_id));
      let n = 0, sum = 0;
      $$(".yd-tl-t").forEach((t, i) => {
        const q = B.items[i];
        if (i === 0) { t.dataset.b = q.id; if (!(q.id in B.on)) B.on[q.id] = true; }
        const on = !!B.on[q.id], tag = t.querySelector(".yd-tl-tag");
        t.classList.toggle("on", on);
        t.querySelector("input").checked = on;
        if (i === 0) {
          tag.hidden = false; tag.className = "yd-tl-tag"; tag.textContent = T.b_ez;
          t.querySelector("[data-tp]").innerHTML = q.c > q.p ? `<b class="sale">${esc(money(q.p, this.fmt))}</b><s>${esc(money(q.c, this.fmt))}</s>` : `<b>${esc(money(q.p, this.fmt))}</b>`;
        } else if (inCart.has(q.id)) { tag.hidden = false; tag.className = "yd-tl-tag in"; tag.textContent = T.b_benne; }
        else tag.hidden = true;
        if (on) { n++; sum += q.p; }
      });
      const words = (T.b_szavak || "").split(",").map((s) => s.trim());
      this.$("[data-bn]").textContent = n ? T.b_n.replace("{n}", n) : T.b_nincs;
      this.$("[data-btot]").textContent = money(sum, this.fmt);
      this.$("[data-bl]").textContent = n ? T.b_gomb.replace("{melyik}", words[n - 1] || n) : T.b_valassz;
      const firstOk = this.v && this.v.a;
      const bad = this.$("[data-badd]");
      bad.disabled = !n || (B.on[B.items[0].id] && !firstOk);
    }
    async baddAll(btn) {
      const B = this.B;
      const items = B.items.filter((q) => B.on[q.id]).map((q) => ({ id: q.id, quantity: 1 }));
      if (!items.length) return;
      const gw = B.on[B.items[0].id] ? this.gift(items[0], 1) : null;
      if (gw) items.push(gw);
      btn.disabled = true;
      let ok = false;
      try {
        this.cart = await cartAdd(items);
        ok = true;
        if (gw) this.giftReset();
        B.items.slice(1).forEach((q) => { B.on[q.id] = false; });
        this.say(this.T.ok);
        this.ship();
      } catch (err) {
        this.say([this.T.hiba, err.message].filter(Boolean).join(" "), true);
      }
      btn.classList.add(ok ? "ok" : "err");
      setTimeout(() => { btn.classList.remove("ok", "err"); this.bsync(); }, 1200);
      this.bsync();
      btn.disabled = true;
    }

    /* ---- tapadó vásárlósáv ---- */
    stickyBar(sig) {
      const bar = this.$("[data-bar]"), pa = this.$("[data-add]");
      if (!bar || !pa) return;
      let past = false, footVis = false;
      const set = () => {
        const on = past && !footVis;
        bar.classList.toggle("on", on);
        bar.setAttribute("aria-hidden", on ? "false" : "true");
        const b = bar.querySelector("[data-baradd]"); if (b) b.tabIndex = on ? 0 : -1;
      };
      const check = () => {
        const h = document.querySelector(".yd-fejlec, sticky-header, header");
        const hb = h ? Math.max(0, h.getBoundingClientRect().bottom) : 0;
        past = pa.getBoundingClientRect().bottom < hb;
        set();
      };
      let raf = 0;
      addEventListener("scroll", () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(check); }, { passive: true, signal: sig.signal });
      addEventListener("resize", check, sig);
      const foot = document.querySelector(".shopify-section-group-footer-group, footer");
      if (foot && "IntersectionObserver" in window) {
        this._io = new IntersectionObserver(([en]) => { footVis = en.isIntersecting; set(); });
        this._io.observe(foot);
      }
      check();
    }

    /* ---- egy oszlopban a Leírás a Termékjellemzők után jön ---- */
    placeDesc(sig) {
      const d = this.$(".yd-tl-desc"), more = this.$(".yd-tl-more"), pd = this.$(".yd-tl-pd"), feat = this.$(".yd-tl-feat");
      if (!d || !more || !pd || !feat) return;
      const place = () => {
        const one = getComputedStyle(pd).gridTemplateColumns.trim().split(/\s+/).length < 2;
        if (one && d.parentNode !== feat.parentNode) feat.after(d);
        else if (!one && d.parentNode !== more) more.prepend(d);
      };
      let raf = 0;
      addEventListener("resize", () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(place); }, sig);
      place();
    }
  }
  customElements.define("yd-termeklap", YdTermeklap);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yodlo-termeksor"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.ydTermeksor) { window.ydTermeksor.initAll(); return; }
  const mobil = window.matchMedia("(max-width:767px)");
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  const MAX_OLDAL = 8;
  const FK = "yd-kedvencek";
  const txt = (el) => (el ? el.textContent.replace(/\s+/g, " ").trim() : "");
  const favGet = () => { try { const v = JSON.parse(localStorage.getItem(FK) || "[]"); return Array.isArray(v) ? v : []; } catch (e) { return []; } };
  const favSet = (a) => { try { localStorage.setItem(FK, JSON.stringify(a)); } catch (e) {} document.dispatchEvent(new CustomEvent("yd:kedvencek")); };
  function favSync() {
    const s = new Set(favGet().map((x) => x.u));
    document.querySelectorAll(".yd-ts .yd-fav").forEach((b) => {
      const on = s.has(b.dataset.u);
      b.classList.toggle("on", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }
  function favToggle(b) {
    const card = b.closest(".yd-card");
    const img = card && card.querySelector(".yd-img1");
    const d = { u: b.dataset.u, t: txt(card && card.querySelector(".yd-ctitle a")), i: img ? img.currentSrc || img.src : "", p: txt(card && card.querySelector(".yd-pr-now")), b: txt(card && card.querySelector(".yd-brand")) };
    const a = favGet();
    const i = a.findIndex((x) => x.u === d.u);
    if (i > -1) a.splice(i, 1); else a.unshift(d);
    favSet(a.slice(0, 60));
    favSync();
  }

  function limit(sec) {
    const g = sec.querySelector(".yd-grid");
    if (!g) return 0;
    const n = parseInt(g.dataset.n, 10) || 8;
    const nm = parseInt(g.dataset.nm, 10) || n;
    return mobil.matches ? Math.min(n, nm) : n;
  }

  function apply(sec) {
    const g = sec.querySelector(".yd-grid");
    if (!g) return 0;
    const f = sec.dataset.f || "";
    const max = limit(sec);
    let db = 0;
    g.querySelectorAll(".yd-card").forEach((c) => {
      const m = f ? (" " + (c.dataset.f || "") + " ").includes(" " + f + " ") : c.dataset.a === "1";
      const lat = m && db < max;
      if (lat) db++;
      c.hidden = !lat;
    });
    const u = sec.querySelector(".yd-ures");
    if (u) u.hidden = db > 0 || !!sec._busy;
    return db;
  }

  async function more(sec) {
    const g = sec.querySelector(".yd-grid");
    if (!g || sec._busy) return;
    sec._busy = true;
    let oldal = 0;
    try {
      while (apply(sec) < limit(sec) && g.dataset.next && oldal < MAX_OLDAL) {
        oldal++;
        const url = (sec.dataset.path || "/") + "?section_id=" + encodeURIComponent(sec.dataset.section) + "&page=" + g.dataset.next;
        const r = await fetch(url, { credentials: "same-origin" });
        if (!r.ok) break;
        const doc = new DOMParser().parseFromString(await r.text(), "text/html");
        const ug = doc.querySelector(".yd-grid");
        if (!ug) break;
        ug.querySelectorAll(".yd-card").forEach((c) => {
          if (!g.querySelector('.yd-card[data-id="' + c.dataset.id + '"]')) g.appendChild(document.importNode(c, true));
        });
        g.dataset.next = ug.dataset.next || "";
      }
    } catch (e) {
      /* hálózati hiba: marad, ami már látszik */
    }
    sec._busy = false;
    apply(sec);
    favSync();
  }

  function init(sec) {
    sec.dataset.f = "";
    apply(sec);
    favSync();
    more(sec);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(".yd-ts").forEach(init);
  }

  function status(sec, txt) {
    const s = sec.querySelector(".yd-status");
    if (!s) return;
    s.textContent = "";
    setTimeout(() => { s.textContent = txt; }, 50);
  }

  async function add(b) {
    const sec = b.closest(".yd-ts");
    const st = sec.querySelector(".yd-status");
    b.disabled = true;
    b.setAttribute("aria-busy", "true");
    let ok = false;
    try {
      const r = await fetch(root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(Object.assign({ items: [{ id: Number(b.dataset.v), quantity: Number(b.dataset.q) || 1 }] }, window.ydFiok ? window.ydFiok.szekciok() : {}))
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.description || d.message || "");
      const c = await (await fetch(root + "cart.js", { headers: { Accept: "application/json" } })).json();
      document.dispatchEvent(new CustomEvent("yodlo:kosar", { detail: { item_count: c.item_count } }));
      if (typeof window.publish === "function" && typeof window.PUB_SUB_EVENTS !== "undefined") window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: "yodlo-termeksor", cartData: c });
      if (window.ydFiok) window.ydFiok.nyit(d);
      ok = true;
      status(sec, (st ? st.dataset.ok : "") + " " + (b.dataset.nev || ""));
    } catch (e) {
      status(sec, [(st ? st.dataset.hiba : ""), e.message].filter(Boolean).join(" "));
    }
    b.removeAttribute("aria-busy");
    b.classList.add(ok ? "ok" : "err");
    setTimeout(() => { b.classList.remove("ok", "err"); b.disabled = false; }, ok ? 900 : 1800);
  }

  document.addEventListener("click", (e) => {
    const fav = e.target.closest(".yd-ts .yd-fav");
    if (fav) {
      e.preventDefault();
      favToggle(fav);
      return;
    }
    const ch = e.target.closest(".yd-ts .yd-fchip");
    if (ch) {
      const sec = ch.closest(".yd-ts");
      sec.querySelectorAll(".yd-fchip").forEach((x) => {
        const on = x === ch;
        x.classList.toggle("on", on);
        x.setAttribute("aria-pressed", on ? "true" : "false");
      });
      sec.dataset.f = ch.dataset.f || "";
      apply(sec);
      more(sec);
      return;
    }
    const b = e.target.closest(".yd-ts button.yd-btn[data-v]");
    if (b && !b.disabled) add(b);
  });

  const valt = () => document.querySelectorAll(".yd-ts").forEach((sec) => { apply(sec); more(sec); });
  if (mobil.addEventListener) mobil.addEventListener("change", valt);

  document.addEventListener("shopify:section:load", (e) => initAll(e.target));
  document.addEventListener("yd:kedvencek", favSync);
  window.addEventListener("storage", (e) => { if (e.key === FK) favSync(); });

  window.ydTermeksor = { initAll };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => initAll());
  else initAll();
})();

  } catch(e) { console.error(e); }
})();
})();
